import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Validation} from '../../util/validation/validation';
import {UiUtils} from '../../util/ui-utils';
import {Shop} from '../../models/shop';
import {ShopService} from '../../services/shop.service';
import {FoodTypeService} from '../../services/food-type.service';

@Component({
    selector: 'restaurant-info',
    templateUrl: 'restaurant-info.html',
    styleUrls: ['restaurant-info.scss']
})
export class RestaurantInfoComponent implements OnInit {

    signupRestaurantForm: FormGroup;
    userRestaurant = new Shop();
    foods = [];
    food;

    constructor(private shopService: ShopService, private uiUtils: UiUtils, private foodTypeService: FoodTypeService) {}

    ngOnInit() {
        this.signupRestaurantForm = new FormGroup({
            name: new FormControl('', [Validators.required, Validators.minLength(3)]),
            businessType: new FormControl(''),
            fullAddress: new FormGroup({
                address: new FormControl('', [Validators.required, Validators.maxLength(255), Validation.addressValidator.bind(this)]),
                postalCode: new FormControl('', [Validators.required, Validation.zipcodeValidator.bind(this)]),
                local: new FormControl('', [Validators.required, Validators.minLength(3), Validation.addressValidator.bind(this)]),
            }),
            nif: new FormControl('', [Validators.required, Validation.fiscalNumberValidator.bind(this)]),
            tel: new FormControl('', [Validators.required, Validation.phoneValidator.bind(this)]),
            email: new FormControl('', [Validators.required, Validators.email]),
            iban: new FormControl('', [Validation.ibanValidator.bind(this)]),
            foods: new FormControl([], []),
        });

        this.shopService.getCurrentShop().subscribe(shop => {
            if (shop) {
                this.userRestaurant = shop;
                this.signupRestaurantForm.patchValue({
                    name: this.userRestaurant.name,
                    businessType: this.userRestaurant.businessType,
                    nif: this.userRestaurant.fiscalNumber,
                    tel: this.userRestaurant.phoneNumber,
                    email: this.userRestaurant.email,
                    iban: this.userRestaurant.iban
                });
                this.signupRestaurantForm.get('fullAddress').patchValue({
                    address: this.userRestaurant.address.addressLine1,
                    postalCode: this.userRestaurant.address.postCode,
                    local: this.userRestaurant.address.local,
                });
            }
        });

    }
}
